import {format} from "date-fns";

export function getDateText(date: string) {
  const eventDate = new Date(date);
  const weekday = format(eventDate, "EEEE");
  const day = eventDate.getDate();
  const month = format(eventDate, "LLL");
  const year = eventDate.getFullYear();

  const dateText = `${weekday}, ${month} ${day}, ${year}`;
  return dateText;
}
